import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import PageWrapper from "Pages/@PageWrapper"
import { MARKETPLACES_ROUTES } from "@constants"
import { commonFiltersValue, isLoadingCommonFilters, isSystemBusy } from "@signals"
import { TourProvider, TourTarget } from "@tour"
import {resetMarketplacesOffersDetailsSignals, marketplacesOffersDetailsIsEmpty} from "./@signals";
import MarketplacesOffersDetailsFilters from "./Filters";
import MarketplacesOffersDetailsTable from "./Table";


const HEIGHT = 200

export default function MarketplacesOffersDetailsPage() {

    useEffect(() => {
        return () => resetMarketplacesOffersDetailsSignals()
    }, [])

    return <PageWrapper
        head={`DIP Insight | ${MARKETPLACES_ROUTES.TITLE}`}
        title={MARKETPLACES_ROUTES.TITLE}
        subtitle={MARKETPLACES_ROUTES.OFFERS_DETAILS_SUBTITLE}
        isEmpty={marketplacesOffersDetailsIsEmpty.value}
        filters={<MarketplacesOffersDetailsFilters />}
        hasErrors={isSystemBusy.value}
        tourPageKey="offersDetails"
    >
        <Grid container spacing={4} sx={{ mt: 1 }}>
            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="offers-details-table" height={350} />
                <MarketplacesOffersDetailsTable />
            </Grid>

        </Grid>
    </PageWrapper>
}